module.exports = __webpack_public_path__ + "img/visa.07f26621.svg";